document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pyramid-menu-toggle').forEach((toggle) => {
    const menu = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!menu) return;

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      menu.classList.toggle('is-open', !isOpen);
    });

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        toggle.setAttribute('aria-expanded', 'false');
        menu.classList.remove('is-open');
      });
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    if (!select) return;

    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const addLabel = section.querySelector('[data-add-label]');

    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const available = option.dataset.available === 'true';
      const compare = option.dataset.comparePrice || '';

      if (price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = compare;
        comparePrice.classList.toggle('is-hidden', !compare);
      }
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? '加入购物车' : '暂时售罄';
    });
  });
});
